// from https://github.com/vitejs/vite/issues/2076#issuecomment-846558772

import './errorOverlay';

const showErrorOverlay = (err: ErrorEvent) => {
  const ErrorOverlay = customElements.get('vite-error-overlay');
  if (ErrorOverlay) document.body.appendChild(new ErrorOverlay(err));
};

const isAuthorEditorLitePreview = () => {
  try {
    return (
      window.parent !== window &&
      window.parent.location.pathname.includes('/editor/')
    );
  } catch {
    return false;
  }
};

if (
  (import.meta.env.DEV || import.meta.env.MODE === 'authoringapp') &&
  !isAuthorEditorLitePreview()
) {
  window.addEventListener('error', showErrorOverlay);

  window.addEventListener('unhandledrejection', ({ reason }) =>
    showErrorOverlay(reason)
  );
}

window.testError = () => {
  throw new Error('test error');
};

window.showErrorOverlay = showErrorOverlay;
